<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  @if (props.type === "number") {
    <new-ui-inputnumber
      [dt]="props.dt"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [label]="props.label"
      [maxFractionDigits]="props.maxFractionDigits"
      [minFractionDigits]="props.minFractionDigits"
      [readonly]="props.readonly"
      [required]="props.required"
      [isVertical]="props.isVertical"
      [badgeDisabled]="props.badgeDisabled"
      [showDashIfEmptyAndReadOnly]="props.showDashIfEmptyAndReadOnly"
    />
  } @else {
    <new-ui-inputtext
      [dt]="props.dt"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [label]="props.label"
      [type]="props.type"
      [readonly]="props.readonly"
      [required]="props.required"
      [isVertical]="props.isVertical"
      [badgeDisabled]="props.badgeDisabled"
      [showDashIfEmptyAndReadOnly]="props.showDashIfEmptyAndReadOnly"
    />
  }

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
